<ui-section [collapsable]="false" title="General">
	<div section-content class="grid grid-cols-2 gap-12">
		<div class="flex flex-col gap-6 h-fit">
			<app-input
				type="number"
				label="Set Estimated Increase For Property Tax"
				[startIcon]="ICON.PERCENTAGE"
				[ngModel]="viewModel_().propertyTaxIncrease"
				(debounce)="onEstPropTaxIncreaseChange($event)"
				step="0.1"
			/>

			<app-input
				label="Default Description Of Cash Shortfall"
				[required]="true"
				[ngModel]="viewModel_().cashShortFallDescription"
				(debounce)="setCastShortFallDesc($event)"
			/>

			<div class="flex flex-col gap-6">
				<h4 class="text-lg font-medium text-gray-950 m-0">
					Software Transaction Fee
				</h4>

				<div class="flex flex-col gap-4">
					<app-select
						label="Display Line Item(s) In"
						[ngModel]="viewModel_().transactionFee.displayLocation"
						(ngModelChange)="onSoftwareTransFeeDisplayLocationChange($event)"
					>
						@for (option of softwareFeeDisplayOptions; track option.value) {
							<option [value]="option.value">
								{{ option.label }}
							</option>
						}
					</app-select>

					@if (
						viewModel_().transactionFee.displayLocation ===
						SoftwareTransactionFeeDisplayLocation.SOA
					) {
						<div class="flex gap-3 flex-nowrap">
							<ui-checkbox
								label="Include HST with fee item"
								[ngModel]="viewModel_().transactionFee.includeHstInBaseFee"
								(ngModelChange)="setIncludeHstInBaseSoftwareTransFee($event)"
							/>
							<i-tabler
								class="h-4 w-4 text-gray-900"
								name="info-square-rounded"
								matTooltip="Adds HST amount to software transaction fee line item such that the disbursement will include HST before charging HST again as part of the Account"
							/>
						</div>
					}
				</div>

				<app-input
					type="cents"
					[ngModel]="viewModel_().transactionFee.priceChange"
					(debounce)="onSoftwareTransFeeAmountChange($event)"
					label="Price Change"
				/>

				<h4 class="text-lg font-medium text-gray-950 m-0">Jurisdiction</h4>

				<div class="flex">
					<ui-checkbox
						[ngModel]="viewModel_().jurisdictionHSTComplianceLetters"
						(ngModelChange)="setJurisdictionHSTComplianceLetters($event)"
						label="Apply HST to compliance letters"
					/>
				</div>
			</div>
		</div>

		<div class="flex flex-col gap-6">
			<ui-button-segmented
				label="Trust Ledger Payable To (Purchase)"
				[options]="purchaseTlPayableToOptions"
				[selectedId]="viewModel_().payableTo.purchase"
				(selectedIdChange)="onPurchaseTlPayableToChange($event)"
				[fullWidth]="true"
				variant="text-only"
				labelSize="md"
			/>

			<ui-button-segmented
				label="Trust Ledger Payable To (Sale & Refinance)"
				[options]="saleRefiTlPayableToOptions"
				[selectedId]="viewModel_().payableTo.saleRefinance"
				(selectedIdChange)="onSaleRefiTlPayableToChange($event)"
				[fullWidth]="true"
				variant="text-only"
				labelSize="md"
			/>

			<div class="flex flex-col gap-6 h-fit">
				<h4 class="text-lg font-medium text-gray-950 m-0">
					Parenthesis In Condensed Financial Tags
				</h4>

				<ui-button-segmented
					label="Sale"
					[options]="parenthesesForTypeOptions"
					[selectedId]="viewModel_().parentheses.sale"
					(selectedIdChange)="setUseParenthesesForSale($event)"
					[fullWidth]="true"
					variant="text-only"
					labelSize="md"
				/>

				<ui-button-segmented
					label="Purchase"
					[options]="parenthesesForTypeOptions"
					[selectedId]="viewModel_().parentheses.purchase"
					(selectedIdChange)="setUseParenthesesForPurchase($event)"
					[fullWidth]="true"
					variant="text-only"
					labelSize="md"
				/>

				<ui-button-segmented
					label="Refinance"
					[options]="parenthesesForTypeOptions"
					[selectedId]="viewModel_().parentheses.refinance"
					(selectedIdChange)="setUseParenthesesForRefinance($event)"
					[fullWidth]="true"
					variant="text-only"
					labelSize="md"
				/>
			</div>
		</div>
	</div>
</ui-section>
